/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Heading } from 'sarsaparilla';

type ImportantDate = {
    description: string;
    view_order?: string;
    display_order?: string;
    start_date: string;
    end_date: string;
};

interface PermitVenueDatesPropTypes {
    permit: {
        important_dates: ImportantDate[];
    };
}

export default function PermitVenueDates({ permit }: PermitVenueDatesPropTypes) {
    const renderHeader = () => {
        return (
            <thead>
                <tr>
                    <th>Dates</th>
                    <th>Information</th>
                </tr>
            </thead>
        );
    };

    const renderRow = (importantDate: ImportantDate) => {
        const {
            description,
            view_order: viewOrder,
            display_order: displayOrder,
            start_date: startDate,
            end_date: endDate,
        } = importantDate;

        const dateDisplayStr = !isEmpty(endDate)
            ? `${startDate} - ${endDate}`
            : `${startDate}`;
        const key = viewOrder || displayOrder || `${Math.random()}`;

        return (
            <tr key={key}>
                <td>{dateDisplayStr}</td>
                <td>{description}</td>
            </tr>
        );
    };

    const importantDates = get(permit, 'important_dates', []);
    if (!importantDates.length) return null;

    return (
        <div id="important-dates">
            <Heading appearance="h5" headingLevel={2}>
                Important Dates
            </Heading>
            <table>
                <caption className="rec-sr-only">Important dates</caption>
                {renderHeader()}
                <tbody>
                    {importantDates.map((d) => {
                        return renderRow(d);
                    })}
                </tbody>
            </table>
        </div>
    );
}
